import { Card } from "@common/components/ui/card"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { PageContent, PageTitle } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { PlaybookCreateForm } from "./-components/form/create-form"

export const Route = createFileRoute(
  "/_layout/settings/_panel/quoting/playbooks/create",
)({
  staticData: { breadcrumb: "New playbook" },
  component: CreatePlaybookPage,
})

function CreatePlaybookPage(): React.ReactElement {
  const navigate = useNavigate()
  const showToast = useCustomToast()

  return (
    <PageContent>
      <PageTitle title="New playbook" />
      <Card className="p-4 shadow-none">
        <PlaybookCreateForm
          onCreate={(created) => {
            showToast("Created", `${created.name} added.`, "success")
            navigate({ to: "/settings/quoting/playbooks" })
          }}
        />
      </Card>
    </PageContent>
  )
}
